module.exports = __webpack_public_path__ + "img/work.bc960515.svg";